import type { Theme } from '../../../shared/contexts/theme/ThemeContext';

export interface InsightsMetricColors {
  /** Time-series (VisibilityCitedChart) — --primary-ux-500. */
  visibility: string;
  /** Time-series (VisibilityCitedChart) — --green-100. */
  cited: string;
  /** Funnel ladder (FunnelVsCompetitors) — --primary-ux-200/300/500, the SAME tokens BrandFunnel's SCSS uses. */
  funnelVisibility: string;
  funnelTop3: string;
  funnelTop1: string;
}

/**
 * Insights metric colors for ECharts charts (canvas — CSS vars don't work there): literal copies of
 * the tokens from variables.scss / dark-theme.scss. The HTML sections (BrandFunnel, PlatformGapBars)
 * use the same tokens directly in SCSS — this helper is for the canvas ONLY (CR decision). The theme
 * is passed explicitly (useTheme().theme) so useMemo gets a real dependency instead of a DOM read.
 *
 * - visibility/cited — full KPI accents (--primary-ux-500 / --green-100);
 * - funnel* — primary-ux-200/300/500 ladder (Top 3 on primary-300 — user decision).
 */
export const getInsightsMetricColors = (theme: Theme): InsightsMetricColors => {
  const dark = theme === 'dark';
  const primary200 = dark ? '#2a3a6a' : '#b3c9fc';
  const primary300 = dark ? '#5080e0' : '#6794fa';
  const primary500 = dark ? '#4a80e8' : '#1b5ff8';
  const green100 = dark ? '#50c890' : '#40b681';

  return {
    visibility: primary500,
    cited: green100,
    funnelVisibility: primary200,
    funnelTop3: primary300,
    funnelTop1: primary500,
  };
};
